import { render, staticRenderFns } from "./StepLayout.vue?vue&type=template&id=99c4208e&scoped=true"
import script from "./StepLayout.vue?vue&type=script&lang=js"
export * from "./StepLayout.vue?vue&type=script&lang=js"
import style0 from "./StepLayout.vue?vue&type=style&index=0&id=99c4208e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c4208e",
  null
  
)

export default component.exports